import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router";
import styled from "styled-components";
import { MessageActions, MessageScreen } from "../components/MessageScreen";
import { actionButtonStyles } from "../styles/actionButton";
import { black } from "../styles/colors";
import { buildDeepLink, buildWebFallback, splatToSegments } from "./deepLink";

/** How long to wait for the app to take over before offering manual options. */
const FALLBACK_DELAY_MS = 2000;

export function Open() {
  const { "*": splat } = useParams();
  const { search, hash } = useLocation();
  const [showFallback, setShowFallback] = useState(false);

  const segments = useMemo(() => splatToSegments(splat), [splat]);
  const deepLink = useMemo(
    () => buildDeepLink(segments, search, hash),
    [segments, search, hash],
  );
  const webFallback = useMemo(
    () => buildWebFallback(segments, search, hash),
    [segments, search, hash],
  );

  useEffect(() => {
    try {
      window.location.replace(deepLink);
    } catch {
      setShowFallback(true);
      return;
    }

    const timer = window.setTimeout(
      () => setShowFallback(true),
      FALLBACK_DELAY_MS,
    );
    return () => window.clearTimeout(timer);
  }, [deepLink]);

  return (
    <MessageScreen
      title="Opening Progress…"
      message={
        showFallback
          ? "If the app did not open, use one of the options below."
          : "Redirecting to the app."
      }
    >
      {showFallback && (
        <MessageActions>
          <PrimaryAction href={deepLink}>Open in Progress app</PrimaryAction>
          <SecondaryAction href={webFallback}>Continue on web</SecondaryAction>
        </MessageActions>
      )}
    </MessageScreen>
  );
}

const PrimaryAction = styled.a(actionButtonStyles);

const SecondaryAction = styled.a({
  color: black,
});
